import type { SxProps, Theme } from "@mui/material/styles";

import type { SearchFieldSize } from "./SearchField.types";

export const root: SxProps<Theme> = {
  width: "100%",
  alignItems: "stretch",
};

export const inputRoot =
  (fieldSize: SearchFieldSize): SxProps<Theme> =>
  (theme) => {
    const fieldHeight = fieldSize === "compact" ? theme.spacing(5.5) : theme.spacing(7);
    return {
      position: "relative",
      alignItems: "stretch",
      padding: 0,
      overflow: "hidden !important",
      boxSizing: "border-box",
      height: fieldHeight,
      minHeight: fieldHeight,
      "& .MuiOutlinedInput-notchedOutline": {
        bottom: 0,
      }
    };
  };

export const adornment: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignSelf: "stretch",
  height: "100%",
  maxHeight: "unset",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  minWidth: theme.spacing(7),
  margin: 0,
  padding: 0,
  boxSizing: "border-box",
  borderRadius: 0,
});
